import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CacheService {
  private cache: { [key: string]: any } = {};

  set(key: string, value: any): void {
    this.cache[key] = value;
  }

  get(key: string): any | null {
    return this.cache.hasOwnProperty(key) ? this.cache[key] : null;
  }
}
